import React from 'react';
import {
    AutoListContainer,
    AutoListMainView,
    BrandContainer,
    BrandName,
    BrandHeader,
} from './AutoListItem.styled';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel.jsx';
import { useTranslation } from 'react-i18next';
  
const AutoListItem = ({
    data,
    titleField,
    descField,
    onSelectItem,
    fSize,
    fontFamily,
    bBottom,
    wordBreak,
    overflowX
}) => {
    const { t } = useTranslation();
    return (
        <AutoListContainer id="receivesets-autolistitem" onClick={() => onSelectItem(data)} bBottom={bBottom}>
            <AutoListMainView>
                <CustomLabel
                    label={
                        data && data[`${titleField}`]
                            ? data[`${titleField}`]
                            : data.cfn
                    }
                    color={'#140f4b !important'}
                    fSize={fSize ? fSize : '14px !important'}
                    fontFamily={fontFamily}
                    overflowX={overflowX}
                    wordBreak={wordBreak}
                />
            </AutoListMainView>
            {data &&
            data[`${descField}`] &&
            (data[`${descField}`] || data.description) ? (
                <CustomLabel
                    label={
                        data && data[`${descField}`]
                            ? data[`${descField}`]
                            : data.description
                    }
                    color={'#140F4B !important'}
                    fSize={'12px !important'}
                    opacity={0.7}
                    fontFamily={'AvenirNextWorld Regular !important'}
                    pt={0}
                    mt={0}
                />
            ) : null}
            {data && data.brand ? (
                <BrandContainer>
                    <BrandHeader>{t('receiveSets.AutoListItem.Brand')} </BrandHeader>
                    <BrandName>{data && data.brand}</BrandName>
                </BrandContainer>
            ) : null}
        </AutoListContainer>
    );
};

export default AutoListItem;
